import type {ApprovalPart, AssistantContentPart} from "@/types/chatMessages";

export function isApprovalPart(part: AssistantContentPart): part is ApprovalPart {
   return part.type === "functionCall" && part.data.approval != null;
}

/** Only the latest reply's approvals can be decided; continuations map back to their proposal. */
export function isApprovalActive(part: ApprovalPart, {messageId, approvalMessageIds, activeMessageId}: {
   messageId?: string;
   approvalMessageIds?: Record<string, string>;
   activeMessageId?: string;
}): boolean {
   return !!messageId && (approvalMessageIds?.[part.data.approval.id] ?? messageId) === activeMessageId;
}

type ContentGroup =
   | {approval: true; parts: ApprovalPart[]; start: number}
   | {approval: false; parts: AssistantContentPart[]; start: number};

/** One review per reply, anchored at its first approval; other content keeps its relative order. */
export function groupApprovalParts(parts: AssistantContentPart[], isUser: boolean): ContentGroup[] {
   const groups: ContentGroup[] = [];
   let approvals: Extract<ContentGroup, {approval: true}> | undefined;
   parts.forEach((part, index) => {
      const previousGroup = groups.at(-1);
      if (!isUser && isApprovalPart(part)) {
         if (approvals) approvals.parts.push(part);
         else {
            approvals = {approval: true, parts: [part], start: index};
            groups.push(approvals);
         }
      } else if (previousGroup && !previousGroup.approval) {
         previousGroup.parts.push(part);
      } else groups.push({approval: false, parts: [part], start: index});
   });
   return groups;
}
